<div class="container  no-padding min-height-100">
    <div class="d-flex justify-content-center mt-5 mb-5">
        <div class="row col-12 d-flex justify-content-center mt-4  no-padding">
            <div class="col-12   row   d-flex justify-content-center  align-items-center   no-padding"
                style="color: #000000;">
                <div class=" col-12 col-md-12 mb-3">

                    <div class="card mt-3">


                        <div class="card-body">


                            <div class="row d-flex  align-items-center ">
                                <div class="col-3 col-sm-1">
                                    <img class="card-img-top" [src]="this.authService.getUser().photoURL">

                                </div>
                                <div class="col-9 col-sm-11  row ">
                                    <p class="card-text text-truncate-2-line col-12 col-sm-4">
                                        {{this.authService.getUser().displayName}}
                                    </p>
                                    <p class="card-text text-truncate-2-line col-12 col-sm-4">
                                        {{this.authService.getUser().email}}</p>

                                </div>
                            </div>

                            <div class="col-2">

                            </div>

                            <div class="col-10">


                            </div>
                        </div>
                    </div>
                </div>





            </div>



        </div>
    </div>

</div>